import Swiper, { Navigation, Pagination, Autoplay }  from "swiper";

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// Home Page Services
const homePageSwiper = new Swiper('.services-swiper', {
    modules: [Navigation, Autoplay, Pagination],
    grabCursor: true,
    speed: 500,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 90,
    preloadImages: false,
    lazy: true,
    navigation: {
        nextEl: '.services-swiper-button-next',
        prevEl: '.services-swiper-button-prev',
    },
    autoplay: {
        delay: 2000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.services-pagination',
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
    },
    breakpoints: {
        1400: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2,
            pagination: {},
        },
    },
});

// Work Example Slider
const workExampleSlide = new Swiper('.work-example-swiper', {
    modules: [Navigation, Autoplay, Pagination],
    grabCursor: true,
    speed: 500,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 90,
    lazy: true,
    preloadImages: false,
    navigation: {
        nextEl: '.work-example-swiper-button-next',
        prevEl: '.work-example-swiper-button-prev',
    },
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
});

const workExampleSlide1 = new Swiper('.work-example-swiper-1', {
    modules: [Navigation, Autoplay, Pagination],
    grabCursor: true,
    speed: 500,
    loop: true,
    slidesPerView: 1,
    lazy: true,
    preloadImages: false,
    spaceBetween: 90,
    navigation: {
        nextEl: '.work-example-swiper-button-next-1',
        prevEl: '.work-example-swiper-button-prev-1',
    },
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    }
});

const workExampleSlide2 = new Swiper('.work-example-swiper-2', {
    modules: [Navigation, Autoplay, Pagination],
    grabCursor: true,
    speed: 500,
    loop: true,
    slidesPerView: 1,
    lazy: true,
    preloadImages: false,
    spaceBetween: 90,
    navigation: {
        nextEl: '.work-example-swiper-button-next-2',
        prevEl: '.work-example-swiper-button-prev-2',
    },
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
    }
});